module.exports = __webpack_public_path__ + "img/heart-question.75784fc3.svg";